import {createContext} from "react";
import type {UserInfoData} from "../lib/ModelTypes.ts";

export interface AuthWrapperContextProps {
    isAuthenticated: boolean;
    userInfo: UserInfoData;
    invalidate(): Promise<void>;
}

const AuthWrapperContext = createContext<AuthWrapperContextProps | null>(null);
export default AuthWrapperContext;